<div class="dt card feed" [ngClass]="selectedTemplate">
    <!--    <p-dropdown-->
    <!--        [(ngModel)]="selectedTemplate"-->
    <!--        [options]="templateOptions"-->
    <!--        [showClear]="true"-->
    <!--        placeholder="Select Template">-->
    <!--        <ng-template let-option pTemplate="item">-->
    <!--            <div class="dropdown-item">-->
    <!--                <i class="pi" [ngClass]="{'pi-clock': option.value === 'legacy', 'pi-star': option.value === 'theme1'}"></i>-->
    <!--                <span>{{ option.label }}</span>-->
    <!--            </div>-->
    <!--        </ng-template>-->
    <!--    </p-dropdown>-->

    <!--    <p>Selected Template: {{ selectedTemplate }}</p>-->

    <p-dataView #dv
                [lazy]="true"
                [layout]="layout"
                [value]="items"
                [first]="first"
                [rows]="rowsAmount"
                [paginator]="true"
                paginatorPosition="both"
                filterBy="code"
                (onPage)="onSearchAndLoadData($event)"
                [sortField]="sortField"
                [sortOrder]="sortOrder"
                [totalRecords]="total">

        <p-header *ngIf="!hideToolbar">
            <div class="ui-helper-clearfix">
                <div class="p-grid justify-content-between" style="align-items: center;">
                    <div class="flex flex-column md:flex-row md:justify-content-between">
                        <ng-container *ngIf="isSortingAvailable">
                            <p-dropdown [options]="sortOptions"
                                        [(ngModel)]="sortKey"
                                        placeholder="Sort By Price"
                                        (onChange)="onSortChange($event)"
                                        styleClass="mb-2 md:mb-0"></p-dropdown>
                        </ng-container>
                    </div>

                    <form *ngIf="!hideSearch"
                          [formGroup]="webshopForm"
                          class="p-col-12 p-md-4 filter-container">
                        <div class="form-group">
                            <label for="code">
                                <span translation="Axilla.Webshop.Article.Search" source="Axilla"></span>
                            </label>
                            <div style="position: relative">
                                <input type="search" id="code"
                                       name="Code"
                                       formControlName="code"
                                       class="form-control"
                                       pInputText
                                       (input)="onSearchAndLoadData()">
                            </div>
                        </div>
                    </form>
                    <div class="p-col-12 p-md-4" style="text-align: right">
                        <p-dataViewLayoutOptions></p-dataViewLayoutOptions>
                    </div>
                </div>
            </div>
        </p-header>

        <ng-template let-item pTemplate="listItem">
            <div class="w-100" [ngSwitch]="selectedTemplate">
                <!-- Template for Type 'legacy' -->
                <div *ngSwitchCase="'legacy'" class="p-col-12 list-item" (click)="onOpenDetails(item)">
                    <ng-container *ngIf="BasePermissionDefinition.Webshop.View.ShowFavoriteArticles | permission">
                        <div class="favorite-container" (click)="toggleFavorites($event, item)">
                            <i class="fa fa-heart" [ngClass]="{'selected': item.favorite}"></i>
                        </div>
                    </ng-container>
                    <div class="product-list-item list-card">
                        <div class="product-list-detail d-flex">

                            <div class="product-image">
                                <img src="{{getImgUrl(item.code)}}" alt="Article picture"/>
                            </div>
                            <div>
                                <div class="product-name">{{ item.title }}</div>
                                <div class="product-description">{{ item.code }}</div>
                                <div class="product-description">{{ item.description }}</div>
                                <!--<p-rating [value]="5" [readonly]="false" [cancel]="false"></p-rating>-->
                                <ng-container *ngFor="let category of item.categories">
                                    <i class="pi pi-tag product-category-icon"></i><span
                                    class="product-category">{{ category.shortName }}</span>
                                </ng-container>
                            </div>
                        </div>
                        <div class="product-list-action" (click)="preventClick($event)">
                            <span
                                class="product-price">{{ item.price | currency:getCurrency():'symbol-narrow':'.2-2' }}</span>
                            <p-spinner [(ngModel)]="item.quantity"
                                       [step]="1"
                                       [min]="0"
                                       OnlyNumber="true"
                                       inputStyleClass="item-quantity"
                                       [formatInput]="true"
                                       thousandSeparator=","
                                       decimalSeparator="."></p-spinner>

                            <p-button icon="pi pi-shopping-cart" label="Add to Cart"
                                      (click)="addToBasket(item)"></p-button>

                            <span *ngIf="item.amount == 1" class="product-badge amount-pce">
                                <span translation="Axilla.OrderGuide.Article.AmountPce" source="Axilla">
                                </span>
                            </span>
                            <span *ngIf="item.amount > 1" class="product-badge amount-box">
                                {{ item.amount }}
                                <span *ngIf="item.amount > 1" translation="Axilla.OrderGuide.Article.AmountBox"
                                      source="Axilla">
                                </span>
                            </span>

                            <ng-container *ngIf="'Pages.App.Webshop.View.ShowAvailableStockInfo' | permission">
                                <div class="list-details-stock-container" *ngIf="isStockAvailable(item)">
                                    {{ item.stockAmount }}
                                    <span *ngIf="item.stockAmount == 1 && item.amount == 1"
                                          translation="Axilla.Apps.Webshop.OnStock.Piece1"
                                          source="AxillaAppWebshop"> </span>
                                    <span *ngIf="item.stockAmount == 1 && item.amount > 1"
                                          translation="Axilla.Apps.Webshop.OnStock.Box1"
                                          source="AxillaAppWebshop"> </span>
                                    <span *ngIf="item.stockAmount > 1 && item.amount == 1"
                                          translation="Axilla.Apps.Webshop.OnStock.Piece"
                                          source="AxillaAppWebshop"> </span>
                                    <span *ngIf="item.stockAmount > 1 && item.amount > 1"
                                          translation="Axilla.Apps.Webshop.OnStock.Box"
                                          source="AxillaAppWebshop"> </span>
                                </div>

                                <div class="list-details-stock-container sold-out"
                                     *ngIf="isStockAvailable(item) && item.stockAmount == 0">
                                    Sold OUT
                                </div>
                            </ng-container>


                            <ng-container *ngIf="'Pages.App.Webshop.View.ShowAvailableStockInfo' | permission">
                                <div class="list-details-stock-container" *ngIf="isGapAvailable(item)">
                                    {{ item.availableAmount }}

                                    <span *ngIf="item.availableAmount == 1 && item.amount == 1"
                                          translation="Axilla.Apps.Webshop.Available.Piece1" source="Axilla"></span>
                                    <span *ngIf="item.availableAmount == 1 && item.amount > 1"
                                          translation="Axilla.Apps.Webshop.Available.Box1" source="Axilla"></span>
                                    <span *ngIf="item.availableAmount > 1 && item.amount == 1"
                                          translation="Axilla.Apps.Webshop.Available.Piece" source="Axilla"></span>
                                    <span *ngIf="item.availableAmount > 1 && item.amount > 1"
                                          translation="Axilla.Apps.Webshop.Available.Box" source="Axilla"></span>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>

                <!-- Template for Type 'theme1' -->
                <div *ngSwitchCase="'theme1'" class="p-col-12 list-item">
                    <div class="product-list-item list-card">
                        <div class="product-list-information"
                             *ngIf="item.promotionText || (isStockAvailable(item) && item.stockAmount == 0)">

                            <ng-container *ngIf="BasePermissionDefinition.Webshop.View.HighlightStockInformation | permission">
                                <div class="sold-out" *ngIf="isStockAvailable(item) && item.stockAmount == 0">
                                    Sold OUT
                                </div>
                            </ng-container>

                            <div class="product-promotion" *ngIf="item.promotionText">
                                {{ item.promotionText }}
                            </div>
                        </div>
                        <div class="product-list-detail d-flex" (click)="onOpenDetails(item)">
                            <div class="product-image">
                                <img src="{{getImgUrl(item.code)}}" alt="Article picture"/>

                                <ng-container *ngIf="BasePermissionDefinition.Webshop.View.ShowFavoriteArticles | permission">
                                    <div class="favorite-container" (click)="toggleFavorites($event, item)">
                                        <i class="fa fa-heart" [ngClass]="{'selected': item.favorite}"></i>
                                    </div>
                                </ng-container>
                            </div>
                            <div class="product-info">
                                <div class="product-name">{{ item.title }}</div>
                                <div class="product-code">{{ item.code }}</div>
                                <div class="product-categories" *ngIf="isCategoriesAvailable(item)">
                                    <ng-container *ngFor="let category of item.categories">
                                        <p-tag icon="pi pi-tag" [styleClass]="'product-category-item'" [rounded]="true"
                                               value="{{category.shortName}}"></p-tag>
                                    </ng-container>
                                </div>
                                <div class="product-description">{{ item.description }}</div>
                            </div>

                            <div class="product-price-section">
                                <div class="price-container">
                                <span class="original-price" *ngIf="item.showOldPrice">
                                    {{ item.oldPrice | currency:getCurrency(item.currency):'symbol-narrow':'.2-2' }}
                                </span>
                                    <span class="current-price">
                                    {{ item.price | currency:getCurrency(item.currency):'symbol-narrow':'.2-2' }}
                                </span>
                                </div>

                                <div class="purchase-price-section" *ngIf="item.showPurchasePrice">
                                    <span class="pp-text">Purchase price</span>
                                    <span class="purchase-price">
                                    {{ item.purchasePrice | currency:getCurrency(item.currency):'symbol-narrow':'.2-2' }}
                                </span>
                                </div>

                                <div class="box-info">
                                <span *ngIf="item.amount == 1" class="product-badge amount-pce">
                                    {{ "Axilla.OrderGuide.Article.AmountPce" | localize }}
                                </span>
                                    <span *ngIf="item.amount > 1" class="product-badge amount-box">
                                    {{ item.amount }}
                                        {{ "Axilla.OrderGuide.Article.AmountBox" | localize }}
                                </span>
                                </div>

                                <div class="p-d-flex gap-2 mt-4 p-align-center">
                                    <div class="p-d-flex gap-2 p-2">
                                        <i class="fa fa-warehouse"></i>
                                        <span>{{ item.stockAmount }}</span>
                                    </div>
                                    <ng-container
                                        *ngIf="BasePermissionDefinition.Webshop.WMS.ViewLocalStock | permission">
                                        <button class="btn mlw p-d-flex" (click)="editLocalWarehouse(item)">
                                            <i class="pi pi-car"></i>
                                            <span>{{ item.localWarehouseAmount }}</span>
                                        </button>
                                    </ng-container>
                                </div>

                                <ng-container *ngIf="'Pages.App.Webshop.View.ShowAvailableStockInfo' | permission">
                                    <div class="list-details-stock-container"
                                         *ngIf="isStockAvailable(item) && item.stockAmount != 0">
                                        {{ item.stockAmount }}
                                        <span *ngIf="item.stockAmount == 1 && item.amount == 1"
                                              translation="Axilla.Apps.Webshop.OnStock.Piece1"
                                              source="AxillaAppWebshop"> </span>
                                        <span *ngIf="item.stockAmount == 1 && item.amount > 1"
                                              translation="Axilla.Apps.Webshop.OnStock.Box1"
                                              source="AxillaAppWebshop"> </span>
                                        <span *ngIf="item.stockAmount > 1 && item.amount == 1"
                                              translation="Axilla.Apps.Webshop.OnStock.Piece"
                                              source="AxillaAppWebshop"> </span>
                                        <span *ngIf="item.stockAmount > 1 && item.amount > 1"
                                              translation="Axilla.Apps.Webshop.OnStock.Box"
                                              source="AxillaAppWebshop"> </span>
                                    </div>

                                </ng-container>

                                <ng-container *ngIf="'Pages.App.Webshop.View.ShowAvailableStockInfo' | permission">
                                    <div class="list-details-stock-container" *ngIf="isGapAvailable(item)">
                                        {{ item.availableAmount }}

                                        <span *ngIf="item.availableAmount == 1 && item.amount == 1"
                                              translation="Axilla.Apps.Webshop.Available.Piece1" source="Axilla"></span>
                                        <span *ngIf="item.availableAmount == 1 && item.amount > 1"
                                              translation="Axilla.Apps.Webshop.Available.Box1" source="Axilla"></span>
                                        <span *ngIf="item.availableAmount > 1 && item.amount == 1"
                                              translation="Axilla.Apps.Webshop.Available.Piece" source="Axilla"></span>
                                        <span *ngIf="item.availableAmount > 1 && item.amount > 1"
                                              translation="Axilla.Apps.Webshop.Available.Box" source="Axilla"></span>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                        <div class="product-list-actions">
                            <div class="product-basket-container">
                                <div class="p-d-flex gap-2">
                                    <i class="pi pi-shopping-cart"></i>
                                    <ng-container *ngIf="isInBasket(item); else emptyBasket">
                                        <span>{{ getBasketAmount(item) }}</span>
                                    </ng-container>
                                    <ng-template #emptyBasket>
                                        <span>0</span>
                                    </ng-template>
                                </div>
                            </div>
                            <!-- Quick Add Section -->
                            <div>
                                <app-quick-add
                                    [label]="'Add to cart in one click:'"
                                    [quickAddAmounts]="getQuickAddAmounts(item)"
                                    [article]="item"
                                    (onQuickAction)="onClickQuickAction($event)"></app-quick-add>
                            </div>
                            <div>
                                <app-universal-counter
                                    [mode]="'horizontal'"
                                    [article]="item"
                                    (addToBasket)="onClickQuickAction($event)"></app-universal-counter>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </ng-template>

        <ng-template let-item pTemplate="gridItem">
            <div class="col-sm-12 col-md-4" [ngSwitch]="selectedTemplate">
                <!-- Template for Type 'legacy' -->
                <div *ngSwitchCase="'legacy'" class="product-grid-item card" (click)="onOpenDetails(item)">
                    <div class="product-grid-item-top">
                        <div *ngFor="let category of item.categories">
                            <i class="pi pi-tag product-category-icon"></i>
                            <span class="product-category">{{ category.shortName }}</span>
                        </div>
                        <span *ngIf="item.amount == 1" class="product-badge amount-pce">
                            <span translation="Axilla.OrderGuide.Article.AmountPce" source="Axilla">
                            </span>
                        </span>
                        <span *ngIf="item.amount > 1" class="product-badge amount-box">
                            {{ item.amount }}
                            <span *ngIf="item.amount > 1" translation="Axilla.OrderGuide.Article.AmountBox"
                                  source="Axilla">
                            </span>
                        </span>
                    </div>
                    <div class="product-grid-item-content">

                        <ng-container *ngIf="BasePermissionDefinition.Webshop.View.ShowFavoriteArticles | permission">
                            <div class="favorite-container" (click)="toggleFavorites($event, item)">
                                <i class="fa fa-heart" [ngClass]="{'selected': item.favorite}"></i>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="'Pages.App.Webshop.View.ShowAvailableStockInfo' | permission">
                            <div class="stock-container" *ngIf="isStockAvailable(item)">
                                {{ item.stockAmount }}
                                <span *ngIf="item.stockAmount == 1 && item.amount == 1"
                                      translation="Axilla.Apps.Webshop.OnStock.Piece1"
                                      source="AxillaAppWebshop"> </span>
                                <span *ngIf="item.stockAmount == 1 && item.amount > 1"
                                      translation="Axilla.Apps.Webshop.OnStock.Box1" source="AxillaAppWebshop"> </span>
                                <span *ngIf="item.stockAmount > 1 && item.amount == 1"
                                      translation="Axilla.Apps.Webshop.OnStock.Piece" source="AxillaAppWebshop"> </span>
                                <span *ngIf="item.stockAmount > 1 && item.amount > 1"
                                      translation="Axilla.Apps.Webshop.OnStock.Box" source="AxillaAppWebshop"> </span>
                            </div>

                            <div class="stock-container sold-out"
                                 *ngIf="isStockAvailable(item) && item.stockAmount == 0">
                                Sold OUT
                            </div>

                            <div class="stock-container" *ngIf="isGapAvailable(item)">
                                {{ item.availableAmount }}

                                <span *ngIf="item.availableAmount == 1 && item.amount == 1"
                                      translation="Axilla.Apps.Webshop.Available.Piece1" source="Axilla"></span>
                                <span *ngIf="item.availableAmount == 1 && item.amount > 1"
                                      translation="Axilla.Apps.Webshop.Available.Box1" source="Axilla"></span>
                                <span *ngIf="item.availableAmount > 1 && item.amount == 1"
                                      translation="Axilla.Apps.Webshop.Available.Piece" source="Axilla"></span>
                                <span *ngIf="item.availableAmount > 1 && item.amount > 1"
                                      translation="Axilla.Apps.Webshop.Available.Box" source="Axilla"></span>
                            </div>
                        </ng-container>

                        <div class="product-image">
                            <div class="product-image-helper"></div>
                            <img src="{{getImgUrl(item.code)}}" alt="Article picture"/>
                        </div>
                        <div class="product-name">{{ item.title }}</div>
                        <div class="product-description">{{ item.code }}</div>
                        <div class="product-description">{{ item.description }}</div>
                        <!--<p-rating [value]="5" [readonly]="true" [cancel]="false"></p-rating>-->
                    </div>
                    <div class="product-grid-item-bottom">
                        <span
                            class="product-price">{{ item.price | currency:getCurrency():'symbol-narrow':'.2-2' }}</span>
                        <div class="tile-view shop-actions" (click)="preventClick($event)">
                            <p-spinner [(ngModel)]="item.quantity"
                                       [step]="1"
                                       [min]="0"
                                       OnlyNumber="true"
                                       inputStyleClass="item-quantity"
                                       [formatInput]="true"
                                       thousandSeparator=","
                                       decimalSeparator="."></p-spinner>
                            <p-button icon="pi pi-shopping-cart" label="Add" (click)="addToBasket(item)"></p-button>
                        </div>
                    </div>
                </div>

                <!-- Template for Type 'theme1' -->
                <div *ngSwitchCase="'theme1'" class="product-grid-item card" (click)="onOpenDetails(item)">
                    <div class="product-grid-item-content">
                        <div class="product-image">
                            <div class="product-image-helper"></div>
                            <img src="{{getImgUrl(item.code)}}" alt="Article picture"/>

                            <ng-container *ngIf="BasePermissionDefinition.Webshop.View.ShowFavoriteArticles | permission">
                                <div class="favorite-container" (click)="toggleFavorites($event, item)">
                                    <i class="fa fa-heart" [ngClass]="{'selected': item.favorite}"></i>
                                </div>
                            </ng-container>
                        </div>

                        <div class="product-info">
                            <div class="product-code">{{ item.code }}</div>
                            <div class="product-name">{{ item.title }}</div>
                            <div class="product-description" *ngIf="item.description">{{ item.description }}</div>
                            <div class="product-categories" *ngIf="isCategoriesAvailable(item)">
                                <ng-container *ngFor="let category of item.categories">
                                    <p-tag icon="pi pi-tag" [styleClass]="'product-category-item'" [rounded]="true"
                                           value="{{category.shortName}}"></p-tag>
                                </ng-container>
                            </div>

                            <div class="product-list-information"
                                 *ngIf="item.promotionText || (isStockAvailable(item) && item.stockAmount == 0)">
                                <ng-container *ngIf="BasePermissionDefinition.Webshop.View.HighlightStockInformation | permission">
                                    <div class="sold-out" *ngIf="isStockAvailable(item) && item.stockAmount == 0">
                                        Sold OUT
                                    </div>
                                </ng-container>

                                <div class="product-promotion" *ngIf="item.promotionText">
                                    {{ item.promotionText }}
                                </div>
                            </div>
                        </div>

                        <div class="product-price-section">
                            <div class="price-container">
                                <span class="original-price" *ngIf="item.showOldPrice">
                                    {{ item.oldPrice | currency:getCurrency(item.currency):'symbol-narrow':'.2-2' }}
                                </span>
                                <span class="current-price">
                                    {{ item.price | currency:getCurrency(item.currency):'symbol-narrow':'.2-2' }}
                                </span>
                            </div>

                            <div class="purchase-price-section" *ngIf="item.showPurchasePrice">
                                <span class="pp-text">Purchase price</span>
                                <span class="purchase-price">
                                    {{ item.purchasePrice | currency:getCurrency(item.currency):'symbol-narrow':'.2-2' }}
                                </span>
                            </div>

                            <div class="box-info">
                                <span *ngIf="item.amount == 1" class="product-badge amount-pce">
                                    {{ "Axilla.OrderGuide.Article.AmountPce" | localize }}
                                </span>
                                <span *ngIf="item.amount > 1" class="product-badge amount-box">
                                    {{ item.amount }}
                                    {{ "Axilla.OrderGuide.Article.AmountBox" | localize }}
                                </span>
                            </div>

                            <div class="p-d-flex p-jc-between w-100 mt-4 p-align-center">
                                <div class="p-d-flex gap-2 p-align-center">
                                    <div class="p-d-flex gap-2 p-2">
                                        <i class="fa fa-warehouse"></i>
                                        <span>{{ item.stockAmount }}</span>
                                    </div>
                                    <ng-container
                                        *ngIf="BasePermissionDefinition.Webshop.WMS.ViewLocalStock | permission">
                                        <button class="btn mlw p-d-flex" (click)="editLocalWarehouse(item)">
                                            <i class="pi pi-car"></i>
                                            <span>{{ item.localWarehouseAmount }}</span>
                                        </button>
                                    </ng-container>
                                </div>

                                <div class="product-basket-container">
                                    <div class="p-d-flex gap-2">
                                        <i class="pi pi-shopping-cart"></i>
                                        <ng-container *ngIf="isInBasket(item); else emptyBasket">
                                            <span>{{ getBasketAmount(item) }}</span>
                                        </ng-container>
                                        <ng-template #emptyBasket>
                                            <span>0</span>
                                        </ng-template>
                                    </div>
                                </div>
                            </div>

                            <ng-container *ngIf="'Pages.App.Webshop.View.ShowAvailableStockInfo' | permission">
                                <div class="list-details-stock-container"
                                     *ngIf="isStockAvailable(item) && item.stockAmount != 0">
                                    {{ item.stockAmount }}
                                    <span *ngIf="item.stockAmount == 1 && item.amount == 1"
                                          translation="Axilla.Apps.Webshop.OnStock.Piece1"
                                          source="AxillaAppWebshop"> </span>
                                    <span *ngIf="item.stockAmount == 1 && item.amount > 1"
                                          translation="Axilla.Apps.Webshop.OnStock.Box1"
                                          source="AxillaAppWebshop"> </span>
                                    <span *ngIf="item.stockAmount > 1 && item.amount == 1"
                                          translation="Axilla.Apps.Webshop.OnStock.Piece"
                                          source="AxillaAppWebshop"> </span>
                                    <span *ngIf="item.stockAmount > 1 && item.amount > 1"
                                          translation="Axilla.Apps.Webshop.OnStock.Box"
                                          source="AxillaAppWebshop"> </span>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="'Pages.App.Webshop.View.ShowAvailableStockInfo' | permission">
                                <div class="list-details-stock-container" *ngIf="isGapAvailable(item)">
                                    {{ item.availableAmount }}

                                    <span *ngIf="item.availableAmount == 1 && item.amount == 1"
                                          translation="Axilla.Apps.Webshop.Available.Piece1" source="Axilla"></span>
                                    <span *ngIf="item.availableAmount == 1 && item.amount > 1"
                                          translation="Axilla.Apps.Webshop.Available.Box1" source="Axilla"></span>
                                    <span *ngIf="item.availableAmount > 1 && item.amount == 1"
                                          translation="Axilla.Apps.Webshop.Available.Piece" source="Axilla"></span>
                                    <span *ngIf="item.availableAmount > 1 && item.amount > 1"
                                          translation="Axilla.Apps.Webshop.Available.Box" source="Axilla"></span>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <div class="product-grid-item-bottom" (click)="preventClick($event)">
                        <app-universal-counter [mode]="'horizontal'"
                                               [article]="item"
                                               (addToBasket)="onClickQuickAction($event)"></app-universal-counter>
                    </div>
                </div>
            </div>
        </ng-template>

    </p-dataView>
</div>
